<div class="prepaid-info" *ngIf="prepaid$ | async">
  <cx-icon [type]="iconType.INFO"></cx-icon>
  Ваша корзина содержит товары, на которые требуется 100% предоплата
</div>
